import { PromptTemplate } from '../types';

const PAGE_TYPES = [
  'Blog Post', 'Article', 'Social Media Post', 'Marketing Copy', 
  'Strategic Plan', 'Meeting Agenda', 'Research Brief', 'Email Template',
  'Newsletter', 'Case Study', 'Whitepaper', 'Press Release', 'Proposal',
  'Report', 'Presentation', 'Product Description', 'Landing Page', 'FAQ',
  'Tutorial', 'Policy Document', 'Other'
];

export const pagePrompt: PromptTemplate = {
  type: 'page',
  template: `First, provide a helpful conversational response that:
1. Acknowledges the user's content creation need naturally
2. Explains why creating this type of page would be valuable for their objectives
3. Provides context about content strategy, audience considerations, or best practices

Then, if you believe the user wants a page creation recommendation, include this structured format below your conversational response:

---RECOMMENDATION---
PAGE TITLE: [clear, descriptive title]
PAGE DESCRIPTION: [detailed description of the page purpose, target audience, and key messages]
PAGE TYPE: [Select ONE of these page types: ${PAGE_TYPES.join(', ')}]
---END RECOMMENDATION---

Provide both the conversational response AND the structured recommendation in a single response. The conversational part maintains natural dialogue flow while the structured part enables action card creation.

OR if you need extra context to provide the perfect recommendation, continue chatting conversationally without the structured format.

If the user asks you to writing content into this page... just respond with "OPEN AI TEXT MAGIC" and nothing else`,
  validation: {
    requiredFields: ['PAGE TITLE', 'PAGE DESCRIPTION', 'PAGE TYPE'],
    stopKeywords: ['---RECOMMENDATION---', '---END RECOMMENDATION---'],
    maxRecommendations: 1,
    allowedValues: {
      'PAGE TYPE': PAGE_TYPES
    }
  }
}; 